import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMoveFolderInside: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="move-folder-inside"><path d="M13 19.25H2.75V3.75H10L12 6.75H21.25V13" stroke="currentColor" strokeWidth="1.5"/><path d="M22 17.25H16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.75 14.25L15.75 17.25L18.75 20.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMoveFolderInside;
